package com.milta.core.localization.translations.en

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Import — Photo",
    titlePdf = "Import — PDF",
    titleSpreadsheet = "Import — Excel / CSV",
    fileSentSuffix = "just sent",
    fileWaitingConnectionLabel = "waiting for connection",
    analysingTitle = "Reading the document…",
    analysingSubtitle = "Extracting the deliveries can take a few seconds.",
    analysingSubtitlePdf = "Claude Haiku extracts the deliveries — this can take a few seconds on a scanned PDF.",
    stepFileSent = "File sent",
    stepExtracting = "Extracting fields",
    stepReview = "Review before adding",
    successTitle = "Delivery detected",
    successSubtitle = "Check the information before adding it to the route.",
    addToRouteButton = "Add to the route",
    scanAnotherButton = "Scan another document",
    partialTitle = "Almost complete",
    partialSubtitle = "One field could not be read on the document.",
    missingFieldPlaceholder = "To complete…",
    partialBannerText = "Some information could not be read. You can validate as is and complete it later, or send a clearer document.",
    retryFileButton = "Send another file",
    validateAndContinueButton = "Validate and continue",
    attemptLabel = "Attempt",
    errorTitleUnreadable = "Unreadable document",
    errorTitleMissingFields = "Information not found",
    errorTitleNetworkError = "Problem during analysis",
    errorTitleGeneric = "Analysis failed",
    errorSubtitle = "We could not detect a delivery on this file.",
    errorBannerSuffixUnreadable = "image too dark or text cut off. Take a well-framed, well-lit photo, or send a clearer file.",
    errorBannerSuffixMissingFields = "no usable information was found. Check the file's content or send another one.",
    errorBannerSuffixNetworkError = "the analysis service hit a network issue. Try again in a few moments.",
    errorBannerSuffixGeneric = "an unexpected error occurred during analysis. Try again or send another file.",
    retryWithNewFileButton = "Retry with another file",
    manualEntryButton = "Enter manually",
    attemptsRemainingNote = "You have 1 attempt left for this document.",
    maxAttemptsTitle = "Still unreadable",
    maxAttemptsSubtitle = "This document could not be read after 2 attempts.",
    maxAttemptsBanner = "Attempt limit reached for this document. Complete the delivery manually, or restart the import with a new document.",
    retryUnavailableButton = "Retry — unavailable",
    newDocumentButton = "Import a new document",
    serviceUnavailableTitle = "Service temporarily unavailable",
    serviceUnavailableSubtitle = "The automatic analysis isn't responding right now.",
    serviceUnavailableBanner = "Try again in a few moments, or complete the delivery manually in the meantime.",
    offlineTitle = "You are offline",
    offlineSubtitle = "Your file is ready but hasn't been sent yet.",
    offlineBanner = "Reconnect to the internet then restart the analysis. Nothing was sent to the server — no attempt was counted.",
    retryOfflineButton = "Retry — no connection",
    unsupportedFormatBanner = "Unsupported file format. Choose a photo, a PDF, or an Excel/CSV file.",
    validationTitle = "Review the deliveries",
    fileRejectedTitle = "File not sent",
    fileRejectedSubtitle = "Choose another file to continue.",
    bannerFileRequired = "no file was selected. Choose a PDF file to continue.",
    bannerInvalidPdfFormat = "unsupported format. Only PDF files are accepted here.",
    bannerFileTooLarge = "file too large. Choose a lighter PDF file.",
    chooseAnotherFileButton = "Choose another file",
)
